import axios from 'axios'

// Empty base URL in dev → requests are relative and the Vite proxy forwards
// /api and /auth to the backend. Same-origin in production. Cookie-based auth,
// so credentials must ride along (see backend/docs/CONVENTIONS.md). The
// X-Requested-With header is our lightweight CSRF guard: a cross-site form
// can't set it, so state-changing requests must carry it (paired with the
// SameSite=Lax session cookie).
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '',
  withCredentials: true,
  headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
})

// When the session is gone (or never existed), the API answers 401 — bounce to
// the login page so the user can sign in. (In dev the auth seam never 401s, so
// this stays dormant.) Don't loop if we're already on /login.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      axios.isAxiosError(error) &&
      error.response?.status === 401 &&
      !window.location.pathname.startsWith('/login')
    ) {
      window.location.assign('/login')
    }
    return Promise.reject(error)
  },
)

/** True when an error from `api` is an HTTP 404 (resource missing or hidden). */
export function isNotFound(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 404
}

